module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t(_vm.$route.name)))])])])]), _vm._v(" "), (_vm.dataReady) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12 stats-col"
  }, [_c('div', {
    staticClass: "card sameheight-item stats",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h4', {
    staticClass: "card-header"
  }, [_vm._v("В мрежата")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "row row-sm stats-container"
  }, [_vm._l((_vm.$config.basicLists.dashCounters), function(dashCounter, key) {
    return _c('div', {
      staticClass: "col-12 col-sm-6 stat-col"
    }, [_c('div', {
      staticClass: "stat-icon"
    }, [_c('router-link', {
      attrs: {
        "to": dashCounter.link
      }
    }, [_c('i', {
      staticClass: "fa text-success",
      class: dashCounter.icon
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "stat"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(" " + _vm._s(_vm.report[key]) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "text-muted",
      attrs: {
        "to": dashCounter.link
      }
    }, [_vm._v(_vm._s(dashCounter.title))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "stat-border"
    })])
  }), _vm._v(" "), _vm._l((_vm.$config.basicLists.resourceTypes), function(resourceType, key) {
    return _c('div', {
      staticClass: "col-12 col-sm-6  stat-col"
    }, [_c('div', {
      staticClass: "stat-icon"
    }, [_c('router-link', {
      attrs: {
        "to": resourceType.link
      }
    }, [_c('i', {
      staticClass: "fa text-success",
      class: resourceType.icon
    })])], 1), _vm._v(" "), _c('div', {
      staticClass: "stat"
    }, [_c('div', {
      staticClass: "value"
    }, [_vm._v(" " + _vm._s(_vm.report.resources[key]) + " ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_c('router-link', {
      staticClass: "text-muted",
      attrs: {
        "to": resourceType.link
      }
    }, [_vm._v(_vm._s(resourceType.title))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "stat-border"
    })])
  })], 2)])])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "row mt-2"
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('div', {
    staticClass: "card",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h4', {
    staticClass: "card-header"
  }, [_vm._v("История")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [(_vm.dataHistoryReady) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "timeline"
  }, _vm._l((_vm.history_records.items), function(item, index) {
    return _c('li', {
      class: {
        'timeline-inverted': index % 2 === 0
      }
    }, [_c('div', {
      staticClass: "timeline-badge",
      class: _vm.$config.basicLists.eventTypes[item.event_type].color
    }, [_c('i', {
      staticClass: "fa",
      class: _vm.$config.basicLists.eventTypes[item.event_type].icon
    })]), _vm._v(" "), _c('div', {
      staticClass: "timeline-panel"
    }, [_c('div', {
      staticClass: "timeline-body"
    }, [_c('p', [_c('c-avatar', {
      staticClass: "float-left",
      attrs: {
        "family": item.family
      }
    }), _vm._v(" "), _c('span', [_vm._v("Семейство " + _vm._s(item.family.name) + "\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.$config.basicLists.eventTypes[item.event_type].text) + "\n\t\t\t\t\t\t\t\t\t\t\t\t"), (item.event_type !== 'new-family') ? _c('router-link', {
      attrs: {
        "to": _vm.$config.basicLists.eventTypes[item.event_type].link + item.target_id
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.info.title) + "\n\t\t\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "text-muted"
    }, [_c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "title": _vm._f("prettyDateTime")(item.createdAt)
      }
    }), _vm._v(" " + _vm._s(_vm._f("fromNowDateTime")(item.createdAt)))])], 1)])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('router-link', {
    attrs: {
      "to": "/events"
    }
  }, [_c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Виж всички")])])], 1)]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('h4', {
    staticClass: "card-header"
  }, [_vm._v("Информация")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_vm._v("\n\t\t\t\t\tОписание на менюто:\n\t\t\t\t\t"), _c('table', {
    staticClass: "table table-hover table-responsive"
  }, [_c('tbody', _vm._l((_vm.$config.basicLists.menuItems), function(menuItem, key) {
    return _c('tr', [_c('td', [_c('router-link', {
      staticClass: "text-nowrap",
      attrs: {
        "to": menuItem.link
      }
    }, [_c('i', {
      staticClass: "fa fa-lg text-success",
      class: menuItem.icon
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(menuItem.title))])])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(menuItem.comment))])])
  }))])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12"
  }, [_c('div', {
    staticClass: "card map-card",
    staticStyle: {
      "min-height": "400px"
    }
  }, [_c('h4', {
    staticClass: "card-header"
  }, [_vm._v("Семейства в България")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "map",
    attrs: {
      "id": "bgMap"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5366475a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/htmlhint-loader?{"configFile":".htmlhintrc.json","failOnError":true}!./src/components/dashboard/Dashboard.vue
// module id = 655
// module chunks = 1